module.exports = __webpack_public_path__ + "img/icon_memo_blue_on.060a6216.png";